<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">{{ getTitle() }}</h3>
    </div>
  </div>
  <form class="form form-group-seperator-dashed" [formGroup]="categoryDescriptionForm">
    <div class="navi-hover scroll card-body" [perfectScrollbar]="{ wheelPropagation: false }">
      <div class="form-group">
        <kt-general-autocomplete
          [appearance]="'fill'"
          [label]="'Category'"
          [loadItemsFunction]="categoryAutocompleteCall"
          [optionFormatter]="filterCategoryFn"
          [valueFormatter]="filterCategoryFn"
          [required]="true"
          [readOnly]="false"
          [control]="categoryDescriptionForm.get('category')"
          [change]="onCategoryChange.bind(this)"
          [dataPath]="'data'"
          [placeholder]="'Select Category'"
          #categoryAutocomplete
        ></kt-general-autocomplete>
        <mat-form-field appearance="fill" class="mat-form-field-fluid">
          <mat-label>Description</mat-label>
          <input matInput formControlName="description" required />
          <mat-error *ngIf="isControlHasError('description', 'required')">
            Description is
            <strong>required</strong>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="card-footer">
      <div class="d-flex justify-content-between">
        <div class="mr-2"></div>
        <div>
          <button (click)="close()" type="button" mat-raised-button matTooltip="Cancel">
            <span translate="GLOBAL.CANCEL">Cancel</span></button
          >&nbsp;
          <button
            type="button"
            mat-raised-button
            color="primary"
            (click)="onSubmit()"
            matTooltip="Save"
          >
            <span>Save</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
